// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Title_titleWrapper__mDvmj","nameText":"Title_nameText__DjqiY","authorText":"Title_authorText__koeR0"};